import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface BevelProps {
  iconSrc: string;
}

export const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;

  & > span {
    color: ${ColorPalette.HEX.CharlestonGreen};
    font-size: 12px;
    line-height: 16px;
    margin-top: 9px;
  }
`;

export const Bevel = styled.div<BevelProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${ColorPalette.HEX.White};
  border-radius: 8px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  border: solid 1px ${ColorPalette.HEX.Cultured4};

  width: 88px;
  min-height: 80px;

  background-image: ${({ iconSrc }) => `url(${iconSrc})`};
  background-repeat: no-repeat;
  background-position: center;
`;
